import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const mediaUrl = (u) => (!u ? null : u.startsWith("http") ? u : `${BACKEND}${u}`);

export function errMsg(e, fallback = "Ocorreu um erro. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmtPrice = (cents, lang = "pt") =>
  new Intl.NumberFormat(lang === "en" ? "en-GB" : "pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0, useGrouping: "always" }).format(cents / 100);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "—");

export const waLink = (number, text) => `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
